import axios from "axios";

import {
  authDeviceWithDomainHeader,
  authWithDomainHeader,
} from "../authServices/auth.header";
import { setVoicemails } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class VoiceMailService {
  // Get Voice Mail List
  async getVoiceMailList(filter = "", domain_uuid = null) {
    return await axios
      .get(API_URL + `pbx-service/voicemail` + filter, {
        headers: domain_uuid
          ? authWithDomainHeader(domain_uuid)
          : authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Update Voice Mail
  async updateVoiceMail(voicemail_uuid, data) {
    return await axios
      .patch(API_URL + `pbx-service/voicemail/${voicemail_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setVoicemails();
        return response.data;
      });
  }

  //delete Voice Mail
  async deleteVoiceMail(voicemail_uuid) {
    return await axios
      .delete(API_URL + `pbx-service/voicemail/${voicemail_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setVoicemails();
        return response.data;
      });
  }

  // Get Voice Mail Message
  async getVoiceMailMessageList(voicemail_uuid) {
    return await axios
      .get(API_URL + `pbx-service/voicemail-message/${voicemail_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete Voice Mail Message
  async deleteVoiceMailMessage(voicemail_uuid, message_uuid) {
    return await axios
      .delete(
        API_URL +
          `pbx-service/voicemail-message/${voicemail_uuid}/${message_uuid}`,
        {
          headers: authDeviceWithDomainHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // Get Voice Mail Greetings List
  async getVoiceMailGreeting(voicemail_id) {
    return await axios
      .get(API_URL + `pbx-service/voicemail-greeting/${voicemail_id}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add Voice Mail Greetings
  async addVoiceMailGreeting(voicemail_id, data) {
    return await axios
      .post(API_URL + `pbx-service/voicemail-greeting/${voicemail_id}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete Voice Mail Greetings
  async deleteVoiceMailGreeting(voicemail_id, voicemail_greeting_uuid) {
    return await axios
      .delete(
        API_URL +
          `pbx-service/voicemail-greeting/${voicemail_id}/${voicemail_greeting_uuid}`,
        { headers: authDeviceWithDomainHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new VoiceMailService();
